import styled from 'styled-components'
import { breakpoints } from '../styles/mediaBreakpoints'

export const WhiteBox = styled.div.attrs<{
  $arr: string[]
  $item: string
}>((props) => ({
  $arr: props.$arr,
  $item: props.$item,
}))`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: black;

  &:hover {
    box-shadow: 4px 4px 8px ${(props) => props.theme.colors['gray-200']};
  }

  border: ${(props) =>
    props.$arr.includes(props.$item)
      ? '1px solid ' + props.theme.colors['gray-500']
      : '1px solid white'};

  @media (max-width: ${breakpoints.mobile}px) {
    min-width: 100%;
  }
`
